import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    page: 0,
    data: [],
    detailUsersPage: 0,
    detailUsersData: [],
    detailUserkeyword: ''
}

export const groupUsersSlice = createSlice({
    name: 'groupUsers',
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setDetailUsersPage: (state, action) => {
            state.detailUsersPage = action.payload;
        },
        setGroupUsers: (state, action) => {
            state.data = action.payload;
        },
        setDetailUsers: (state, action) => {
            state.detailUsersData = action.payload
        },
        setDetailUsersKeyword: (state, action) => {
            state.detailUserkeyword = action.payload
        },
        clear: () => initialState
    }
})

export const { setPage, setGroupUsers, setDetailUsers, setDetailUsersPage, setDetailUsersKeyword, clear } = groupUsersSlice.actions;
export default groupUsersSlice.reducer;